import axios, { AxiosResponse } from "axios";
import { ApiSearchResponse } from "../models/common";
import { ISearchParams, searchParamsInit } from "../models/searchParams";
import { IAddEditShip, IShip } from "../models/ship";
import { IShipDispatcher } from "../models/shipDispatcher";

export const addShip = async (dto: IAddEditShip): Promise<AxiosResponse<IShip>> => {
    return await axios.post("/docks/ship", dto);
};

export const changeShip = async (dto: IAddEditShip): Promise<AxiosResponse<IShip>> => {
    return await axios.patch("/docks/ship", dto);
};

export const updateDockAccess = async (dto: IShipDispatcher): Promise<AxiosResponse<IShip>> => {
    return await axios.patch("/dispatcher/ship/change", dto);
};

export const deleteShip = async (id: string): Promise<AxiosResponse<string>> => {
    return await axios.delete(`/docks/ship/${id}`);
};

export const getShip = async (id: string): Promise<AxiosResponse<IShip>> => {
    return await axios.get(`/docks/ship/${id}`);
};

export const getShipDisp = async (id: string): Promise<AxiosResponse<IShipDispatcher>> => {
    return await axios.get(`/dispatcher/ship/${id}`);
};

export const searchShip = async (
    searchParams: ISearchParams = searchParamsInit,
): ApiSearchResponse<IShip> => {
    return await axios.post("/docks/ship/search", searchParams);
};

export const searchShipDisp = async (
    searchParams: ISearchParams = searchParamsInit,
): ApiSearchResponse<IShipDispatcher> => {
    return await axios.post("/dispatcher/ship/search", searchParams);
};

export const getShipNames = async () => {
    return (await axios.get<string[]>("/docks/expense/shipNames", {})).data;
};
